import { axiosWithAuth } from "../../helpers";

export const merchantGeneralTabService = {
	getMerchant,
	editGeneralInfo,
	addMerchant,
	getMerchantLogo,
	addMerchantLogo,
	deleteMerchantLogo,
	getHierarchy,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getMerchant(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/generalinfo/${id}`,
	};

	return axiosWithAuth(options);
}

function editGeneralInfo(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/merchants/updateGeneralInfo`,
	};

	return axiosWithAuth(options);
}

function addMerchant(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/merchants/addMerchant`,
	};

	return axiosWithAuth(options);
}

function getMerchantLogo(merchantId) {
	//Add random version to prevent loading img from cache
	let randomVersion = Math.random();

	let user = JSON.parse(localStorage.getItem("user"));
	return `${API_URL}/api/merchants/list/${merchantId}/logo?token=${user.access_token}&v${randomVersion}`;
}

function addMerchantLogo(merchantId, document) {
	let changeLogoModel = new FormData();
	let file = document.file;

	changeLogoModel.append("Logo", file);
	changeLogoModel.append("Name", document.name);
	changeLogoModel.append("Extension", file.name.split(/[.]+/).pop());

	return axiosWithAuth({
		method: "POST",
		data: changeLogoModel,
		url: `${API_URL}/api/merchants/list/${merchantId}/logo`,
		headers: { "Content-Type": undefined },
	});
}

function deleteMerchantLogo(merchantId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/merchants/list/${merchantId}/logo`,
	};

	return axiosWithAuth(options);
}

function getHierarchy({ merchantId, page = 0, pageSize = PAGE_SIZE }) {
	const options = {
		method: "GET",
		params: {
			page,
			pageSize,
		},
		url: `${API_URL}/api/merchants/${merchantId}/hierarchy`,
	};

	return axiosWithAuth(options);
}
